import { useSelector } from "react-redux";
import { request } from "../../store/modules/RequestStore";

// import noOrders from "./../../assets/images/orders.png";

import Scrollbar from "../../components/widgets/Scrollbar";
import { Card } from "../../components/RequestPage/TabWorkOrder/WorkOrder";
import { WorkOrders } from "../../components/RequestPage/TabWorkOrder/WorkOrderElements";
import { useTranslation } from "react-i18next";

const TabWorkOrder = () => {
  const { t } = useTranslation();
  const requestState = useSelector(request);
  return (
    <WorkOrders className="lg:px-8">
      <div className={`w-full h-16 flex items-center`}>
        {requestState.workOrders.length > 0 && (
          <p>{t("requestDetail.tabWorkOrder.text")}</p>
        )}
      </div>
      <div className="w-full">
        {requestState.workOrders.length > 0 ? (
          <Scrollbar>
            <div className="">
              {requestState.workOrders.map((workOrder, index) => {
                return <Card key={index} workOrder={workOrder} />;
              })}
            </div>
          </Scrollbar>
        ) : (
          <div className="flex flex-col items-center justify-center h-96">
            {/* <img className="w-48" src={noOrders} alt="asset" /> */}
            <p className="text-sm sm:text-md md:text-lg">
              {t("requestDetail.tabWorkOrder.empty")}
            </p>
          </div>
        )}
      </div>
    </WorkOrders>
  );
};

export default TabWorkOrder;
